import React from 'react'
import styled from 'styled-components'
import BuildingDesc from './BuildingDesc'

import {
  Icon,
  RowFlexDiv,
  ColumnFlexDiv,
  P,
  UserProfilePicture,
  UserProfilePictureHolder,
  SearchFlexDiv,
  SInput,
} from '../Common/CommonStyle'
import { NudistaMedium16, NudistaMedium14 } from '../Common/Fonts'

const MosiacAssignments = ({ assignments }) => {
  const [mosiacExpandedView, setMosiacExpandedView] = React.useState(0)
  return (
    <RowFlexDiv
      width='75%'
      height='100%'
      alignSelf='flex-start'
      flexFlow='row wrap'
      justifyContent='flex-start'
      padding='0% 1% 2% 0%'
    >
      <BuildingDesc />
      {assignments.length > 0
        ? assignments?.map((value) => (
            <ColumnFlexDiv
              width='20%'
              marginTop='2%'
              gap='5px'
              alignItems='center'
              justifyContent='center'
            >
              <AssignmentFLexDiv key={value.id}>
                <Icon
                  width='100%'
                  height='100%'
                  src='/images/mainView/assignmentsView/stock_home.jpg'
                  onClick={() => setMosiacExpandedView(value.id)}
                />
              </AssignmentFLexDiv>
              <RowFlexDiv width='80%'>
                <NudistaMedium14 textAlign='center' color='primary'>
                  002_Roof top Destruction
                </NudistaMedium14>
              </RowFlexDiv>
            </ColumnFlexDiv>
          ))
        : null}
    </RowFlexDiv>
  )
}

const Company = () => {
  return (
    <ColumnFlexDiv width='15%' justifyContent='flex-start'>
      <UserProfilePictureHolder width='35px' height='35px'>
        <UserProfilePicture
          width='35px'
          src='/images/mainView/assignmentsView/stock_home.jpg'
        />
      </UserProfilePictureHolder>
      <P width='10px' textAlign='center' fontSize='9px'>
        Company Name
      </P>
    </ColumnFlexDiv>
  )
}

export const AssignmentFLexDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-overflow: ellipsis;
  top: ${(props) => props.top};
  padding: 4px 4px 4px 4px;
  position: ${(props) => props.position};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  :hover {
    background-color: ${(props) => props.hoverbackgroundColor || '#fb8f02'};
  }
  background-color: ${(props) => props.backgroundColor};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
`

export default MosiacAssignments
